import { useMaxDownpayment, useTreatmentCost } from '@futurefamily/ef-components';
import { useLocation } from 'react-router-dom';
import { payment } from '@futurefamily/ef-utils';

export function useForm (loanMinimum, defaultTerm) {
  const location = useLocation();
  const maxDownPayment = useMaxDownpayment(loanMinimum);
  const query = new URLSearchParams(location.search);

  const treatmentCost = useTreatmentCost();
  const term = Number(query.get('term') ?? defaultTerm);

  const downpayment = payment.getDownpayment(treatmentCost ?? 0, maxDownPayment, loanMinimum);

  const initialValues = {
    cost: treatmentCost || '',
    downpayment,
    term
  };

  function onSubmit () {}

  return { initialValues, onSubmit };
}
